import { Grid } from "antd";
import { createContext, PropsWithChildren, useContext } from "react";
import { LayoutContextType } from "./data";

const LayoutContext = createContext<LayoutContextType>({
  getHeaderPadding: () => "var(--padding-header-xs)",
  getHeaderHeight: () => "var(--layout-header-height-xs)",
  getContentPadding: () => "var(--padding-content-xs)",
  getLeftSiderWidth: () => "100%",
  getMargin: () => "-20px",
});

type LayoutContextProviderType = PropsWithChildren & {};

export const LayoutContextProvider = ({
  children,
}: LayoutContextProviderType) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const getHeaderPadding = () => {
    if (screens.xxl) return "var(--padding-header-xxl)";
    if (screens.xl) return "var(--padding-header-xl)";
    if (screens.lg) return "var(--padding-header-lg)";
    if (screens.sm) return "var(--padding-header-sm)";
    return "var(--padding-header-xs)"; // Default for xs or smaller
  };

  const getMargin = () => {
    if (screens.sm) return "-26px";
    return "-20px";
  };

  const getHeaderHeight = () => {
    if (screens.md) return "var(--layout-header-height-md)";
    if (screens.sm) return "var(--layout-header-height-sm)";
    return "var(--layout-header-height-xs)"; // Default for xs or smaller
  };

  const getContentPadding = () => {
    if (screens.xl) return "var(--padding-content-xl)";
    if (screens.lg) return "var(--padding-content-lg)";
    if (screens.md) return "var(--padding-content-md)";
    if (screens.sm) return "var(--padding-content-sm)";
    return "var(--padding-content-xs)"; // Default for xs or smaller
  };

  const getLeftSiderWidth = () => {
    if (screens.xxl) return "342px";
    if (screens.xl) return "342px";
    if (screens.lg) return "240px";
    if (screens.md) return "240px";
    if (screens.sm) return "100%";
    return "100%"; // Default for xs or smaller
  };

  return (
    <LayoutContext.Provider
      value={{
        getHeaderPadding,
        getHeaderHeight,
        getContentPadding,
        getLeftSiderWidth,
        getMargin,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const LoadingValue = useContext(LayoutContext);
  return LoadingValue;
};
